import type { AlertModel } from '@/shared/generated'

import React from 'react'
import { filter } from 'lodash/fp'
import { useTranslation } from 'react-i18next'

import { getAlertVariant } from '@/entities/price-alert'

import {
	Alert,
	AlertDescription,
	AlertTitle,
} from '@/shared/components/ui/alert'
import { AlertLevel } from '@/shared/generated'

type NotificationsProps = {
	alerts?: AlertModel[]
}
export const SkuSidebarAlerts = ({ alerts }: NotificationsProps) => (
	<>
		{filter({ level: AlertLevel.Unassigned }, alerts)?.map((message) => (
			<MessageListItem key={message.id} message={message} />
		))}
		{filter({ level: AlertLevel.Critical }, alerts)?.map((message) => (
			<MessageListItem key={message.id} message={message} />
		))}
		{filter({ level: AlertLevel.Warning }, alerts)?.map((message) => (
			<MessageListItem key={message.id} message={message} />
		))}
	</>
)

function MessageListItem({ message }: { message: AlertModel }) {
	const { t } = useTranslation()

	return (
		<Alert
			key={message.id}
			data-testid={message.id}
			variant={getAlertVariant(message.level)}
			className='w-full'
		>
			<AlertTitle>{t(message.name, { defaultValue: message.name })}</AlertTitle>
			<AlertDescription>
				{t(message.description, { defaultValue: message.description })}
			</AlertDescription>
		</Alert>
	)
}
